angular.module('app').directive('formaPagamento', function ($filter) {
    return {
        restrict: 'E',
        templateUrl: '/html/forma-pagamento.html?v=' + angular.element('meta[name="version-id"]').attr('content'),
        scope: {
            ngModel: '=',
            valorMinimoParcela: '@',
            maxParcelas: '@',
            editarPerfil: '@',
            perfil: '=?',
            isValorRecorrente: '=?'
        },
        controller: function ($scope, $timeout, $http) {

            $scope.anos_validade = [];
            $scope.formas_pagamentos = [];

            $scope.setFormaPagamento = function (forma) {
                $scope.ngModel.forma_pagamento_id = forma.id;
                $scope.ngModel.forma_pagamento = forma;
            }

            $scope.setParcelamentoDisponivel = function () {
                var valor = $scope.ngModel.valor_liquido.numeroToNumber();
                var res = Math.floor(valor / $scope.valorMinimoParcela);

                if (res < 1) {
                    res = 1;
                }

                $scope.parcelamentoDisponivel = [];

                for (var i = 1; i <= res && i <= $scope.maxParcelas; i++) {
                    $scope.parcelamentoDisponivel.push({
                        nr_parcela: i,
                        valor_parcela: Number((valor / i).toFixed(2)).numberToNumero().rsPrefix()
                    });
                }
            }

            $scope.initAnosValidade = function () {
                for (var i = moment().year(); i < moment().add('year', 50).year(); i++) {
                    $scope.anos_validade.push(i);
                }
            }

            $scope.changeNrParcelas = function () {
                $scope.ngModel.valor_liquido_parcela = $scope.getOpcaoParcelamentoByNrParcelas($scope.ngModel.nr_parcelas).valor_parcela;
            }

            $scope.getOpcaoParcelamentoByNrParcelas = function (nr_parcelas) {
                for (var i in $scope.parcelamentoDisponivel) {
                    if (nr_parcelas === $scope.parcelamentoDisponivel[i].nr_parcela) {
                        return $scope.parcelamentoDisponivel;
                    }
                }

                return {};
            }

            $scope.getFormasPagamentos = function () {
                return $http({
                    url: '/formas-pagamentos/select',
                    ignorarCatchInterceptor: true,
                }).then(function (res) {
                    $scope.formas_pagamentos = res.data;
                }).catch(function (err) {
                    console.error(err);
                });
            }

            $scope.definirPrimeiraFormaPagamentoVisivel = function () {
                const formasVisiveis = $filter('filterFormasRecorrencia')($scope.formas_pagamentos, $scope.isValorRecorrente);

                if (formasVisiveis.length > 0) {
                    $scope.setFormaPagamento(formasVisiveis[0]);
                }
            }
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.$watch('ngModel.valor_liquido', function (newValue, oldValue) {
                $scope.setParcelamentoDisponivel();
            });

            $scope.initAnosValidade();

            $scope.$watch('isValorRecorrente', function (newValue, oldValue) {
                $scope.definirPrimeiraFormaPagamentoVisivel();
            });

            $scope.getFormasPagamentos().then(function () {
                $scope.definirPrimeiraFormaPagamentoVisivel();
            });
        }
    };
})
    .filter('filterFormasRecorrencia', [function () {
        return function (items, isValorRecorrente) {
            var out = [];

            out = items.filter(function (item) {
                if (!isValorRecorrente) return true;
                else return item.permite_recorrencia;
            });

            return out;
        };
    }]);